import axios from "axios";

import { isFunction } from "../lib";

// Constants
const BASE_URL = window.BASE_URL ?? import.meta.env.VITE_APP_API;

// Variables
let token = null;
let handleResponseFulfilled = null;
let handleResponseRejected = null;
let refreshHandler = null;
let refreshPromise = null;

const httpInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        "X-Requested-With": "XMLHttpRequest",
    },
    withCredentials: true,
});

httpInstance.defaults.trailingSlash = true;
httpInstance.interceptors.response.use(
    (response) => {
        handleResponseFulfilled && handleResponseFulfilled();

        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        const status = error?.response?.status;
        const isRefreshRequest =
            originalRequest?.url?.includes("/token/refresh");

        // На 401 сначала пробуем один раз обновить токен и повторить запрос —
        // сессия и несохранённые данные не теряются. Только если refresh не
        // удался, отдаём ошибку в handleResponseRejected (там SPA-переход на
        // логин без location.reload). Защиты: _retry (не зациклить один запрос),
        // исключение самого /token/refresh, единый refreshPromise на все
        // параллельные 401.
        if (
            status === 401 &&
            refreshHandler &&
            originalRequest &&
            !originalRequest._retry &&
            !isRefreshRequest
        ) {
            originalRequest._retry = true;

            try {
                if (!refreshPromise) {
                    refreshPromise = Promise.resolve()
                        .then(() => refreshHandler())
                        .finally(() => {
                            refreshPromise = null;
                        });
                }

                await refreshPromise;

                return httpInstance(originalRequest);
            } catch (refreshError) {
                handleResponseRejected && handleResponseRejected(error);

                return Promise.reject(refreshError);
            }
        }

        handleResponseRejected && handleResponseRejected(error);

        return Promise.reject(error);
    }
);

const setHeaders = (headers) => {
    httpInstance.defaults.headers = headers;
};

const addHeaders = (headers) => {
    httpInstance.defaults.headers = {
        ...httpInstance.defaults.headers,
        ...headers,
    };
};

const setBaseUrl = (url) => {
    httpInstance.defaults.baseURL = url;
};

const setToken = (t) => {
    token = t;
};

const setResponseFulfilledHandler = (handler) => {
    if (isFunction(handler)) handleResponseFulfilled = handler;
};

const setResponseRejectedHandler = (handler) => {
    if (isFunction(handler)) handleResponseRejected = handler;
};

const setRefreshHandler = (handler) => {
    if (isFunction(handler)) refreshHandler = handler;
};

export default httpInstance;
export {
    setHeaders,
    addHeaders,
    setBaseUrl,
    setToken,
    setResponseFulfilledHandler,
    setResponseRejectedHandler,
    setRefreshHandler,
    token,
};
